// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes loading-bar-anim {\n  0% {\n    width: 0%;\n  }\n  100% {\n    width: 100%;\n  }\n}\n\n.loading-bar {\n  height: 100%;\n  width: 100%;\n  background-color: #457537;\n  animation-name: loading-bar-anim;\n  animation-duration: 4s;\n  animation-iteration-count: 0;\n}\n", ""]);
// Exports
module.exports = exports;
